/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ModalFullScreen/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsHovered from 'Simple/hooks/useIsHovered'
import useIsMedia from 'Simple/hooks/useIsMedia'
import { DialogOverlay as ViewsModalOverlay, DialogContent as ViewsModalOverlayContent } from '@reach/dialog'



/** @type {import('Simple/types.js').View} */
export default function ModalFullScreen({
  children,
  viewPath = "/DesignSystem/ModalFullScreen",
  id,
  dangerouslyBypassFocusLock,
  onClick,
  onDismiss,
  borderBottomLeftRadius = 8,
  borderBottomRightRadius = 8,
  borderTopLeftRadius = 8,
  borderTopRightRadius = 8,
  height = "70%",
  paddingTop = 24,
  paddingBottom = 24,
  paddingLeft = 24,
  paddingRight = 24,
  overflowX = "visible",
  overflowY = "visible",
  width = 740,
  maxWidth = "auto",
  maxHeight = "auto",
  size
  
}) {
  let isBefore = useIsBefore()
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  let isMedia = useIsMedia()
let dtModalfullscreenBackgroundcolorBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'ModalFullScreen.backgroundColor.base'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<ViewsModalOverlay
  data-testid="ModalFullScreen.Vertical"
  data-view-path={viewPath}
 id={id}
 dangerouslyBypassFocusLock={dangerouslyBypassFocusLock}
 isOpen={true}
 {...isHoveredBind}
 onClick={onClick}
 onDismiss={onDismiss}
 style={{'--bc-1-Gircl': dtModalfullscreenBackgroundcolorBase}}
 className={`views-block ${styles.Vertical}`}
>
<ViewsModalOverlayContent
  data-testid="ModalFullScreen.ModalContent"
  data-view-path={viewPath}
 style={{'--bc-1-Gircl': dtColorsWhite,'--bblr-2-Gircl': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-3-Gircl': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-4-Gircl': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-5-Gircl': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--pt-7-Gircl': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--pb-8-Gircl': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pl-9-Gircl': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-10-Gircl': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--ox-11-Gircl': overflowX,'--oy-12-Gircl': overflowY,'--mw-16-Gircl': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,'--mh-17-Gircl': typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight,'--w-15-Gircl': isMedia.mobile ? "98%" : size === "large" ? "740px" : size === "medium" ? "540px" : size === "small" ? "360px" : typeof width === 'number' ? `${width}px` : width,'--h-6-Gircl': size === "large" ? "auto" : size === "medium" ? "auto" : size === "small" ? "auto" : typeof height === 'number' ? `${height}px` : height,'--o-13-Gircl': isBefore ? 0 : 1,'--ty-14-Gircl': isBefore ? "20px" : "0px"}}
 className={`views-block ${styles.ModalContent}`}
>
<Children
  viewPath={`${viewPath}/Children`}
>
{children}
</Children>
</ViewsModalOverlayContent>
</ViewsModalOverlay>
</React.Fragment>)
}